import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { PopUpConfirmComponent } from "../../components/ui-components/pop-ups/pop-up-confirm/pop-up-confirm.component";
import { DropdownOption } from "../../components/ui-components/dropdown/dropdown.model";
import { FormInputType } from "../../components/ui-components/forms/form-input/form-input.model";
import { PopUpConfirmResult } from "../../components/ui-components/pop-ups/pop-up-confirm/pop-up-confirm.model"; 

export interface ConfirmOptions {
    title?: string;
    message: string;
    confirmButtonText?: string;
    showInput?: boolean;
    inputType?: FormInputType;
    inputPlaceholder?: string;
    dropdownPlaceholder?: string;
    dropdownOptions?: DropdownOption[];
    maxValue?: number;
    panelClass?: string;
}

@Injectable({ providedIn: "root" })
export class PopUpDialogConfirmService {
    private readonly translate = inject(TranslateService);
    constructor(private dialog: MatDialog) { }

    async confirm(opts: ConfirmOptions): Promise<PopUpConfirmResult | null> {
        const dialogRef = this.dialog.open(PopUpConfirmComponent, {
            panelClass: opts.panelClass || "full-screen-dialog",
            disableClose: true,
        });

        // set instance inputs
        const inst = dialogRef.componentInstance;
        inst.title = opts.title ? this.translate.instant(opts.title) : '';
        inst.message = opts.message ? this.translate.instant(opts.message) : '';
        inst.confirmButtonText = opts.confirmButtonText ? this.translate.instant(opts.confirmButtonText) : this.translate.instant('webPos.Confirm');
        inst.showInput = opts.showInput ?? false;
        inst.inputType = opts.inputType ?? FormInputType.Text;
        inst.inputPlaceholder = opts.inputPlaceholder ? this.translate.instant(opts.inputPlaceholder) : '';
        inst.dropdownPlaceholder = opts.dropdownPlaceholder ? this.translate.instant(opts.dropdownPlaceholder) : '';
        inst.dropdownOptions = opts.dropdownOptions ?? [];
        inst.maxValue = opts.maxValue ?? null;

        // wait for it to close and return the payload
        return firstValueFrom(dialogRef.afterClosed());
    }
}
